<script>
export let image;
export let city;
export let name;
export let title;
export let phone;
export let phone2;
export let email;
</script>

<div class="col-md-6">
  <div class="contact-person">
    <div class="image"><img src="{image}" alt="{name}" /></div>
    <div class="content">
      <p class="city">{city}</p>

      <h4>{name}</h4>

      <p>{title}</p>

      <p class="mb-none">
        <strong>Telefon:</strong>
        <a href="tel:{phone}">{phone}</a>
        <a href="tel:{phone2}">{phone2}</a>
      </p>

      <p class="email mb-none">
        <strong>E-post:</strong>
        <a href="mailto:{email}">{email}</a>
      </p>
    </div>
  </div>
</div>
